import React from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter} from 'react-router-dom';
import {ApolloProvider} from '@apollo/client';
import {ConfigProvider, App as AntdApp} from 'antd';
import enUS from 'antd/locale/en_US';
import zhCN from 'antd/locale/zh_CN';
import esES from 'antd/locale/es_ES';
import './index.css';
import App from './App';
import {client} from './graphql/client';
import {theme} from './theme';
import './i18n';
import {useTranslation} from 'react-i18next';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import 'dayjs/locale/es';
import 'dayjs/locale/en';
import {initSplitRouteCacheClient} from './pages/delivery/splitOrder/utils/splitRouteCacheUtil';
// 注入 Apollo Client 到分单缓存工具
initSplitRouteCacheClient(client);

const getAntdLocale = (lang: string) => {
    switch (lang) {
        case 'zh':
            dayjs.locale('zh-cn');
            return zhCN;
        case 'es':
            dayjs.locale('es');
            return esES;
        default:
            dayjs.locale('en');
            return enUS;
    }
};

// 响应式的 ConfigProvider 包装组件，监听语言变化并动态更新 locale
const ResponsiveConfigProvider: React.FC<{children: React.ReactNode}> = ({children}) => {
    const {i18n} = useTranslation();
    // 规范化语言代码，只取前两位（如 'zh-CN' -> 'zh'），确保 getAntdLocale 能正确匹配
    const currentLang = (i18n.resolvedLanguage || i18n.language || 'en').toLowerCase().split('-')[0];
    const antdLocale = getAntdLocale(currentLang);

    return (
        <ConfigProvider
            locale={antdLocale}
            theme={theme}
            form={{
                requiredMark: (label, { required }) => (
                    <>
                        {label}
                        {required && <span className="text-red-500 ml-1">*</span>}
                    </>
                ),
            }}
        >
            {children}
        </ConfigProvider>
    );
};

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <React.StrictMode>
        <ApolloProvider client={client}>
            <ResponsiveConfigProvider>
                <AntdApp>
                    <BrowserRouter>
                        <App/>
                    </BrowserRouter>
                </AntdApp>
            </ResponsiveConfigProvider>
        </ApolloProvider>
    </React.StrictMode>
); 